import React, { useState } from "react";
import CommonSpinner from "@widgets/CommonSpinner";
import Button from "@mui/material/Button";

interface SnSearchBtnProps {
  text: string;
  onClick: () => void;
  inputRef?: any;
  spinner?: boolean;
  sx?: any;
}

export function SnSearchBtn({
  text,
  onClick,
  inputRef,
  spinner,
  sx,
}: SnSearchBtnProps) {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    setIsLoading(true);
    try {
      await onClick();
    } catch (e) {}
    setIsLoading(false);
  };

  return (
    <span>
      {spinner && <CommonSpinner isLoading={isLoading} />}
      <Button
        ref={inputRef}
        variant="outlined"
        size="small"
        onClick={() => {
          spinner ? handleClick() : onClick();
        }}
        sx={sx}
      >
        {text}
      </Button>
    </span>
  );
}

export default React.memo(SnSearchBtn);
